import React from 'react';
import {
    Box
} from "@mui/material/";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';



function MxTab(props) {




    if ((props.submitedform != false) && (props.mxrecordpresent)) {

        console.log(props.mxrecords);

        return (

            <React.Fragment>

                <TableContainer component={Paper}>
                    <Table sx={{ Width: '50%' }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell><b>Preference</b></TableCell>
                                <TableCell align="center"><b>Hostnames</b></TableCell>
                                <TableCell align="center"><b>Addresses</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>





                            {(props.mxrecords).map((mxrecords, i) => (

                                (mxrecords).map((mxrecord, i) => (


                                 



                                        <TableRow

                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                <b>{mxrecord['preference']}</b>
                                            </TableCell>
                                            <TableCell align="center">{mxrecord['hostname']}</TableCell>
                                            <TableCell align="center">

                                                {(mxrecord.addresses).map((addresse, i) => (
                                                    <div key={i}>
                                                        {addresse}

                                                    </div>

                                                ))}</TableCell>
                                        </TableRow>


                                   


                                ))







                            ))}









                        </TableBody>
                    </Table>
                </TableContainer>































            </React.Fragment>

        )
    } else if ((props.mxrecordpresent == false) && (props.submitedform == true)) {

        return (

            <React.Fragment>
                <br></br>
                <h4>No MX record</h4>
            </React.Fragment>

        );
    }
    else if (props.submitedform == false) {

        return (

            <React.Fragment>
            </React.Fragment>

        );
    }
}

export default MxTab;